<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="body-rw Chapter-rw" epub:type="bodymatter chapter" id="toc">
<nav epub:type="toc">
<h1 class="toc-title">Contents</h1>
<ol class="none" epub:type="list">
<li class="toc-front" id="cover"><span href="#/cover" title="Link target outside of Sample">COVER</span></li>
<li class="toc-front" id="titlepage"><span href="#/titlepage" title="Link target outside of Sample">TITLE PAGE</span></li>
<li class="toc-front" id="toc-copyright"><span href="#/copyright" title="Link target outside of Sample">COPYRIGHT</span></li>
<li class="toc-front" id="toc-dedication"><a href="#/dedication">DEDICATION</a></li>
<li class="toc-chapter1" id="Ref_202429a"><a href="#/chapter001#Ref_202429">CHAPTER ONE</a></li>
<li class="toc-chapter" id="Ref_202359a"><a href="#/chapter002#Ref_202359">CHAPTER TWO</a></li>
<li class="toc-chapter" id="Ref_202362a"><a href="#/chapter003#Ref_202362">CHAPTER THREE</a></li>
<li class="toc-chapter" id="Ref_202365a"><span href="#/chapter004#Ref_202365" title="Link target outside of Sample">CHAPTER FOUR</span></li>
<li class="toc-chapter" id="Ref_202368a"><span href="#/chapter005#Ref_202368" title="Link target outside of Sample">CHAPTER FIVE</span></li>
<li class="toc-chapter" id="Ref_202371a"><span href="#/chapter006#Ref_202371" title="Link target outside of Sample">CHAPTER SIX</span></li>
<li class="toc-chapter" id="Ref_202374a"><span href="#/chapter007#Ref_202374" title="Link target outside of Sample">CHAPTER SEVEN</span></li>
<li class="toc-chapter" id="Ref_202377a"><span href="#/chapter008#Ref_202377" title="Link target outside of Sample">CHAPTER EIGHT</span></li>
<li class="toc-chapter" id="Ref_202380a"><span href="#/chapter009#Ref_202380" title="Link target outside of Sample">CHAPTER NINE</span></li>
<li class="toc-chapter" id="Ref_202383a"><span href="#/chapter010#Ref_202383" title="Link target outside of Sample">CHAPTER TEN</span></li>
<li class="toc-chapter" id="Ref_202386a"><span href="#/chapter011#Ref_202386" title="Link target outside of Sample">CHAPTER ELEVEN</span></li>
<li class="toc-chapter" id="Ref_202389a"><span href="#/chapter012#Ref_202389" title="Link target outside of Sample">CHAPTER TWELVE</span></li>
<li class="toc-chapter" id="Ref_202392a"><span href="#/chapter013#Ref_202392" title="Link target outside of Sample">CHAPTER THIRTEEN</span></li>
<li class="toc-chapter" id="Ref_202395a"><span href="#/chapter014#Ref_202395" title="Link target outside of Sample">CHAPTER FOURTEEN</span></li>
<li class="toc-chapter" id="Ref_202399a"><span href="#/chapter015#Ref_202399" title="Link target outside of Sample">CHAPTER FIFTEEN</span></li>
<li class="toc-chapter" id="Ref_202402a"><span href="#/chapter016#Ref_202402" title="Link target outside of Sample">CHAPTER SIXTEEN</span></li>
<li class="toc-chapter" id="Ref_202405a"><span href="#/chapter017#Ref_202405" title="Link target outside of Sample">CHAPTER SEVENTEEN</span></li>
<li class="toc-chapter" id="Ref_202408a"><span href="#/chapter018#Ref_202408" title="Link target outside of Sample">CHAPTER EIGHTEEN</span></li>
<li class="toc-chapter" id="Ref_202411a"><span href="#/chapter019#Ref_202411" title="Link target outside of Sample">CHAPTER NINETEEN</span></li>
<li class="toc-chapter" id="Ref_202414a"><span href="#/chapter020#Ref_202414" title="Link target outside of Sample">CHAPTER TWENTY</span></li>
<li class="toc-chapter" id="Ref_202417a"><span href="#/chapter021#Ref_202417" title="Link target outside of Sample">CHAPTER TWENTY-ONE</span></li>
<li class="toc-chapter" id="Ref_202420a"><span href="#/chapter022#Ref_202420" title="Link target outside of Sample">CHAPTER TWENTY-TWO</span></li>
<li class="toc-chapter" id="Ref_202423a"><span href="#/chapter023#Ref_202423" title="Link target outside of Sample">CHAPTER TWENTY-THREE</span></li>
<li class="toc-chapter1" id="toc-discover"><a href="#/discoverpage">DISCOVER MORE</a></li>
<li class="toc-chapter" id="Ref_202353b"><span href="#/appendix001" title="Link target outside of Sample">EXTRAS</span></li>
<li class="toc-chaptera" id="Ref_202353a"><span href="#/appendix001#Ref_202353" title="Link target outside of Sample">MEET THE AUTHOR</span></li>
<li class="toc-chaptera" id="Ref_202356a"><span href="#/appendix002#Ref_202356" title="Link target outside of Sample">INTERVIEW</span></li>
<li class="toc-chaptera" id="Ref_202497a"><span href="#/teaser001#Ref_202497" title="Link target outside of Sample">A PREVIEW OF <em>TWO CAN PLAY</em></span></li>
<li class="toc-chaptera" id="Ref_202500a"><span href="#/teaser002#Ref_202500" title="Link target outside of Sample">A PREVIEW OF <em>DEAD RINGER</em></span></li>
<li class="toc-chapter" id="Ref_202509a"><a href="#/adcard#Ref_202509">BY KATE KESSLER</a></li>
<li class="toc-chapter" id="Ref_202503a"><span href="#/praise#Ref_202503" title="Link target outside of Sample">PRAISE FOR <em>IT TAKES ONE</em></span></li>
</ol>
</nav>
<nav class="hidden-tag" epub:type="landmarks" hidden="hidden">
<h1>Navigation</h1>
<ol class="none" epub:type="list">
<li><a epub:type="bodymatter" href="#/chapter001">Begin Reading</a></li>
<li><a epub:type="toc" href="#/toc">Table of Contents</a></li>
</ol>
</nav>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?51d8b39c